import { ReactComponent } from "./more-line.svg";

const MoreLineIcon = () => <ReactComponent />;

export default MoreLineIcon;
